import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AnalyticsRouterSync = () => {
  const location = useLocation();

  useEffect(() => {
    window.__ANALYTICS__?.setPage?.(location.pathname);
  }, [location.pathname]);

  return null;
};

export default AnalyticsRouterSync;